import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PwaInstallService {

  installable = signal<boolean>(false);
  private deferredPrompt: any = null;

  constructor() {
    // Pick up prompt captured in main.ts before Angular bootstrapped
    const earlyPrompt = (window as any).__pwaInstallPrompt;
    if (earlyPrompt) {
      this.deferredPrompt = earlyPrompt;
      this.installable.set(true);
      delete (window as any).__pwaInstallPrompt;
    }

    window.addEventListener('beforeinstallprompt', (event: Event) => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.installable.set(true);
    });

    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
      this.installable.set(false);
    });
  }

  async install(): Promise<boolean> {
    if (!this.deferredPrompt) {
      return false;
    }
    this.deferredPrompt.prompt();
    const result = await this.deferredPrompt.userChoice;
    this.deferredPrompt = null;
    this.installable.set(false);
    return result.outcome === 'accepted';
  }
}
